import Errors from './Errors';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }


    /**
     * Send a GET request to the given URL.
     *
     * @param {string} url
     */
    get(url) {
        return this.submit('get', url);
    }


    /**
     * Send a POST request to the given URL.
     *
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }


    /**
     * Send a PUT request to the given URL.
     *
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }


    /**
     * Send a PATCH request to the given URL.
     *
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }


    /**
     * Send a DELETE request to the given URL.
     *
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            // use FormData object to support uploading of files
            var formData = new FormData();

            // Note: HTML form do not support PUT, PATCH or DELETE actions. So, when defining PUT,
            // PATCH or DELETE routes that are called from an HTML form, you will need to add a 
            // hidden _method field to the form. The value sent with the _method field will be use as 
            // the HTTP request method.
            formData.append('_method', requestType.toUpperCase());

            // add the key/value pairs from this.data() to the FormData object
            for(let fieldName in this.data()) {
                if(this[fieldName] instanceof FileList) {
                    // append the list of files to the form data object to support uploading of multiple files
                    for(var index = 0; index < this[fieldName].length; index++ ) {
                        let file = this[fieldName][index];
                        formData.append(fieldName + '[' + index + ']', file);
                    }
                } else {
                    formData.append(fieldName, this[fieldName]);
                }
            }

            // Note: Currently our Form class does not support GET actions, only POST, PUT, PATCH and DELETE.
            // All these methods are sent using an axios POST request with form method spoofing.
            axios['post'](url, formData)
                .then(response => {
                    this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    // handle server exceptions (e.g. when uploading a file that is larger than the maximum allowable size limit configured on the server)
                    // Note: When a server exception is encountered, it is up to the calling function to populate the form with a custom error message.
                    if(error.response.data.exception) {
                        reject(error.response);
                    } else {
                        this.onFail(error.response.data.errors);
                        reject(error.response.data.errors);
                    }
                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}

export default Form;